// Single source of truth for all categories and subcategories.
// Used by: Mega Menu, Add/Edit Product modals, Product table filters.

export const categoryData: Record<string, string[]> = {
    "Stationary": [
        "Paper - 75 GSM",
        "Pen / Pensil",
        "Dairy",
        "Registers",
        "Files",
        "Box File",
        "Stapler",
        "Punch",
        "Tap",
        "Gum Stick",
        "Highlighter",
        "Whitener",
        "Calculator",
        "Pin",
        "Sticky Notes",
        "Color Paper",
        "File stand",
        "cuntainers",
        "Box"
    ],
    "Furniture": [
        "Computer Table"
        , "Executive Table-Boss Table"
        , "Conference Table"
        , "Lunch Table"
        , "Chairs"
        , "Visiting Chairs"
        , "Rolling Chair"
        , "Boss Chair"
        , "Fix Chair"
        , "Sofa"
        , "Coutch"
        , "Bed"
        , "Dinning Table"
        , "Centre Table"
        , "Side Table"
        , "Podium"
        , "Almirah"
        , "Rack"
        , "Standing Table"
        , "Cupboards"
        , "Tissue Box Holder"
        , "Matress"
    ],
    "IT Products": [
        "Computers",
        "Printers",
        "Scanner",
        "Laptop",
        "Projector",
        "Modem",
        "Key Board",
        "Mouse",
        "Switch",
        "VC Camara",
        "Mic",
        "CCTV Camara",
        "Pendrive",
        "Harddisk",
        "Door Bell",
        "HDMI Cable",
        "Power Cable",
        "Laptop Stand",
        "Laptop Bag",
    ],
    "Electronic": [
        "Air Conditione",
        "Fan",
        "Table fan",
        "Exhost fan",
        "Wall fan",
        "Coffe Machine",
        "Tea making machine",
        "RO",
        "Water Cooler",
        "Fire extingues",
        "Freeze",
        "Television",
        "Digital Standy",
        "Extention Board"
    ],
    "Gift Items": [
        "Clock",
        "Bags",
        "Jute Bags",
        "Jute Files",
        "Bottles",
        "Cup",
        "Dairy Set",
        "Cap",
        "keychain",
        "Tshirts",
        "Crokary set",
        "Tray",
        "Glass",
        "Pens",
        "Organizer",
        "Table Mat",
        "Mouse Pad",
        "Laptop Bag",
        "Travell Bag",
        "Brass items"
    ],
    "Textile": [
        "Towel",
        "Hand Towel",
        "Curtains",
        "Bedsheet",
        "Floor Mat",
        "Door Mat",
        "Coir Mat",
        "Bothroom Accessories",
        "Engle",
        "Sofa Cover",
        "Cushion cover",
        "Home Décor",
        "carpet",
        "Pellow",
        "Tea Coster"

    ],
};

export const categoryList = Object.keys(categoryData);

export const getSubcategories = (category: string): string[] => {
    return categoryData[category] || [];
};
